import { checkStatus, get, toJson } from "../helpers/fetch";
import { IInstalments } from "../models/IInstalments.model";

class FinanceService {

	private apiURL = '/api/finance';

	async getInstalments(total: number): Promise<IInstalments[]> {
		return get(`${this.apiURL}/banners/${total}`)
			.then(checkStatus)
			.then(toJson);
	}

}

export default FinanceService;
